module.exports = __webpack_public_path__ + "img/th_Man_Sand.4da6f16b.jpg";